<template>
  <client-only>
    <div class="app__form">
      <div
        v-if="!partnerStore.getBuyoutPartner"
        class="formItem formItem--1x12 formItem--img"
      >
        <v-autocomplete
          v-model="selectedBonusPartner"
          :items="availableBonusPartners"
          :label="t('buyout.appraisal.seller')"
          :placeholder="t('buyout.appraisal.find_seller')"
          item-title="fe_name"
          clearable
          return-object
          persistent-clear
          menu-icon=""
          :menu-props="{ contentClass: 'formItem--img'}"
          @update:model-value="buyoutStore.loadAvailableNewMetaMasters(); unfocus()"
          @update:search="(val) => { if (val) selectedBonusPartner = null }"
          @blur="() => { if (!selectedBonusPartner) { buyoutStore.loadAvailableNewMetaMasters(); }} /* this ensures the reset of next fields when nothing is selected */"
        >
          <template #item="{ props, item }">
            <v-list-item
              v-bind="props"
              :title="''"
            >
              <template #prepend>
                <img
                  class="img img--partner"
                  :src="item?.raw?.logo"
                >
              </template>
              <div class="desc">
                {{ item?.raw?.fe_name }}
              </div>
              <div
                v-if="item?.raw?.max_bonus_value > 0"
                class="amount color--greenTone1 font-weight-regular"
              >
                <!-- ToDo will be bonus up to or only bonus? -->
                <span>{{ item?.raw?.more_bonus_values_available ? t('buyout.appraisal.bonus_up_to_partner') : t('buyout.appraisal.bonus_up_to') }}</span> <strong>{{ useCurrency(item?.raw?.max_bonus_value) }}</strong>
              </div>
            </v-list-item>
          </template>
          <template #selection="{ item }">
            <v-list-item :title="''">
              <template #prepend>
                <img class="img img--partner" :src="item?.raw?.logo">
              </template>
              <div class="desc">
                {{ item?.raw?.fe_name }}
              </div>
              <div
                v-if="item?.raw?.max_bonus_value > 0"
                class="amount color--greenTone1 font-weight-regular"
              >
                <!-- ToDo will be bonus up to or only bonus? -->
                <span>{{ item?.raw?.more_bonus_values_available ? t('buyout.appraisal.bonus_up_to_partner') : t('buyout.appraisal.bonus_up_to') }}</span> <strong>{{ useCurrency(item?.raw?.max_bonus_value) }}</strong>
              </div>
            </v-list-item>
          </template>
        </v-autocomplete>
      </div>
      <div
        v-if="(partnerStore.getBuyoutPartner || selectedBonusPartner) && selectedBonusPartner?.seo_name !== 'other'"
        class="formItem formItem--1x12 formItem--img"
      >
        <v-autocomplete
          v-model="selectedNewMetaMaster"
          :label="partnerStore?.getBuyoutPartner ? t('buyout.appraisal.new_device_model') : t('buyout.appraisal.new_device_model_seller')"
          :placeholder="t('buyout.appraisal.find_device')"
          :items="availableNewMetaMasters"
          :disabled="bonusesLoading || minorBonusesLoading"
          :loading="bonusesLoading || minorBonusesLoading"
          item-title="name"
          clearable
          return-object
          persistent-clear
          menu-icon=""
          :menu-props="{ contentClass: 'formItem--img'}"
          @update:model-value="metaMasterChange(); unfocus()"
          @update:search="(val) => { if (val) selectedNewMetaMaster = null }"
          @blur="() => { if (!selectedNewMetaMaster) { metaMasterChange(); }} /* this ensures the reset of next fields when nothing is selected */"
        >
          <template #item="{ props , item }">
            <v-list-item
              v-bind="props"
              :title="''"
            >
              <template #prepend>
                <img class="img img--device" :src="buildImageUrl(item?.raw?.image || '')">
              </template>
              <div class="desc">
                {{ item?.raw?.name }}
              </div>
              <div class="amount color--greenTone1 font-weight-regular">
                <!-- ToDo will be bonus up to or only bonus? -->
                <span>{{ t('buyout.appraisal.bonus_up_to') }}</span> <strong>{{ useCurrency(item?.raw?.max_bonus_value) }}</strong>
              </div>
            </v-list-item>
          </template>
          <template #selection="{ item }">
            <v-list-item :title="''">
              <template #prepend>
                <img class="img img--device" :src="buildImageUrl(item?.raw?.image || '')">
              </template>
              <div class="desc">
                {{ item?.raw?.name }}
              </div>
              <div class="amount color--greenTone1 font-weight-regular">
                <!-- ToDo will be bonus up to or only bonus? -->
                <span>{{ t('buyout.appraisal.bonus_up_to_partner') }}</span> <strong>{{ useCurrency(item?.raw?.max_bonus_value) }}</strong>
              </div>
            </v-list-item>
          </template>
        </v-autocomplete>
      </div>

      <template v-if="selectedNewMetaMaster?.is_other">
        <div class="formItem formItem--1x12 formItem--img">
          <v-autocomplete
            v-model="selectedNewManufacturer"
            :label="t('buyout.appraisal.new_device_model_manufacturer')"
            :placeholder="t('buyout.appraisal.find_manufacturer')"
            :items="availableNewManufacturers"
            item-title="name"
            clearable
            return-object
            persistent-clear
            menu-icon=""
            :menu-props="{ contentClass: 'formItem--img'}"
            @update:model-value="buyoutStore.loadAvailableOthersMetaMasters(); unfocus()"
            @update:search="(val) => { if (val) selectedNewManufacturer = null }"
            @blur="() => { if (!selectedNewManufacturer) { buyoutStore.loadAvailableOthersMetaMasters(); }} /* this ensures the reset of next fields when nothing is selected */"
          >
            <template #item="{ props , item }">
              <v-list-item
                v-bind="props"
                :title="''"
              >
                <template #prepend>
                  <img class="img img--device" :src="buildImageUrl(item?.raw?.logo || '')">
                </template>
                <div class="desc">
                  {{ item?.raw?.name }}
                </div>
              </v-list-item>
            </template>
            <template #selection="{ item }">
              <v-list-item :title="''">
                <template #prepend>
                  <img class="img img--device" :src="buildImageUrl(item?.raw?.logo || '')">
                </template>
                <div class="desc">
                  {{ item?.raw?.name }}
                </div>
              </v-list-item>
            </template>
          </v-autocomplete>
        </div>
        <div v-if="selectedNewManufacturer" class="formItem formItem--1x12 formItem--img">
          <v-autocomplete
            v-model="selectedOthersNewMetaMasters"
            :label="partnerStore?.getBuyoutPartner ? t('buyout.appraisal.new_device_model') : t('buyout.appraisal.new_device_model_seller')"
            :items="buyoutStore.availableOthersNewMetaMasters"
            :disabled="buyoutStore.newManufacturersLoading"
            :loading="buyoutStore.newManufacturersLoading"
            item-title="name"
            clearable
            return-object
            persistent-clear
            menu-icon=""
            :menu-props="{ contentClass: 'formItem--img'}"
            @update:model-value="buyoutStore.loadAvailableNewMasters(true); unfocus()"
            @update:search="(val) => { if (val) selectedOthersNewMetaMasters = null }"
            @blur="() => { if (!selectedOthersNewMetaMasters) { buyoutStore.loadAvailableNewMasters(true); }} /* this ensures the reset of next fields when nothing is selected */"
          >
            <template #item="{ props , item }">
              <v-list-item
                v-bind="props"
                :title="''"
              >
                <template #prepend>
                  <img class="img img--device" :src="buildImageUrl(item?.raw?.image || '')">
                </template>
                <div class="desc">
                  {{ item?.raw?.name }}
                </div>
                <div class="amount color--greenTone1 font-weight-regular">
                  <!-- ToDo will be bonus up to or only bonus? -->
                  <span>{{ t('buyout.appraisal.bonus_up_to') }}</span> <strong>{{ useCurrency(item?.raw?.max_bonus_value) }}</strong>
                </div>
              </v-list-item>
            </template>
            <template #selection="{ item }">
              <v-list-item :title="''">
                <template #prepend>
                  <img class="img img--device" :src="buildImageUrl(item?.raw?.image || '')">
                </template>
                <div class="desc">
                  {{ item?.raw?.name }}
                </div>
                <div class="amount color--greenTone1 font-weight-regular">
                  <!-- ToDo will be bonus up to or only bonus? -->
                  <span>{{ t('buyout.appraisal.bonus_up_to') }}</span> <strong>{{ useCurrency(item?.raw?.max_bonus_value) }}</strong>
                </div>
              </v-list-item>
            </template>
          </v-autocomplete>
        </div>
      </template>
      <v-progress-circular v-if="mastersLoading" />
      <div
        v-if="availableNewProductVariants?.attr_values && !mastersLoading"
        class="formItem formItem--1x12"
      >
        <div :class="['app__label', newDeviceErrors?.variant ? 'color--redTone2' : '', selectedNewProductVariant?.id ? 'is-checked': '']">
          {{ availableNewProductVariants?.device_attr_name?.name }}
        </div>
        <div class="bVariant">
          <div
            v-for="variant in sortedAttrValues"
            :key="variant.id"
            :class="['bVariant__item', variant.id === selectedNewProductVariant?.id ? 'is-selected': '', 'cursor-pointer']"
            @click="selectVariant(variant)"
          >
            {{ variant.attribute_choice.value }}
          </div>
        </div>
        <div
          v-if="newDeviceErrors?.variant"
          class="app__label app__label--noIcon color--redTone2 mt-3"
        >
          {{ newDeviceErrors.variant }}
        </div>
      </div>
      <div
        v-if="availableNewProductColors?.length>0"
        class="formItem formItem--1x12"
      >
        <div :class="['app__label', newDeviceErrors?.color ? 'color--redTone2' : '', selectedNewProductColor?.id ? 'is-checked': '']">
          {{ t("buyout.appraisal.color") }}
        </div>
        <v-progress-circular v-if="colorLoading" />
        <div v-else class="bVariant bVariant--color text-center">
          <div
            v-for="colorVariant in availableNewProductColors"
            :key="colorVariant.id"
            :class="['bVariant__item', colorVariant.id === selectedNewProductColor?.id ? 'is-selected' : '', 'cursor-pointer']"
            @click="setSelectedColor(colorVariant)"
          >
            <img :src="buildImageUrl(colorVariant?.image || '')" class="img-responsive">
            <div class="first-letter-uppercase">
              {{ colorVariant.color.name }}
            </div>
          </div>
        </div>
        <div v-if="selectedNewProductColor && selectedBonusPartner && bonusPeriod?.new_device_in_bonus_period" class="color--grayTone3 mt-10 app__title--h7">
          <div>
            {{ t("static.bonuses.new_device_in_date_range") }}
          </div>
          <div>
            {{ `${formatDateHumanReadable(bonusPeriod.valid_from)} - ${formatDateHumanReadable(bonusPeriod.valid_until)}` }}
          </div>
        </div>
        <div
          v-if="newDeviceErrors?.color"
          class="app__label app__label--noIcon color--redTone2 mt-3"
        >
          {{ newDeviceErrors?.color }}
        </div>
      </div>
    </div>
  </client-only>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { orderBy } from "lodash-es";
import useCurrency from "cashtec-common/src/composables/useCurrency";

const { buildImageUrl } = useUtils();
const buyoutStore = useBuyoutStore();
const { formatDateHumanReadable } = useUtils();
const partnerStore = usePartnerStore();
const { t } = useI18n();
const {
  selectedOthersNewMetaMasters,
  selectedNewMetaMaster,
  selectedNewProductVariant,
  selectedNewManufacturer,
  availableNewManufacturers,
  selectedNewProductColor,
  availableNewMetaMasters,
  availableBonusPartners,
  availableNewProductColors,
  availableNewProductVariants,
  colorLoading,
  mastersLoading,
  bonusesLoading,
  selectedBonusPartner,
  minorBonusesLoading,
  newDeviceErrors,
  bonusPeriod
} = storeToRefs(buyoutStore);

const sortedAttrValues = computed<BuyoutDeviceAttributeValue[]>(() => {
  if (!availableNewProductVariants?.value?.attr_values?.length) { return []; }

  return orderBy(
    availableNewProductVariants.value.attr_values,
    [attrValue => (parseInt(attrValue.attribute_choice.value.split(" ")[0]))],
    "asc"
  ) as BuyoutDeviceAttributeValue[];
});

function metaMasterChange () {
  if (selectedNewMetaMaster.value?.is_other) {
    buyoutStore.loadAvailableNewManufacturers();
  } else {
    buyoutStore.loadAvailableNewMasters();
  }
}

async function selectVariant (variant: BuyoutDeviceAttributeValue) {
  selectedNewProductVariant.value = variant;
  newDeviceErrors.value.variant = "";
  await buyoutStore.loadBonusPeriod();
  await buyoutStore.loadAvailableNewColors();
}

async function setSelectedColor (colorVariant: BuyoutProductColor) {
  selectedNewProductColor.value = colorVariant;
  newDeviceErrors.value.color = "";
  await buyoutStore.loadBuyoutBonuses();
}

/** Removes focus from the currently focused element */
function unfocus () {
  if (document.activeElement instanceof HTMLElement) {
    document.activeElement?.blur();
  }
}

</script>

<style scoped>
.selected-color{
    background-color: red;
}
.color:hover{
    box-shadow: 0 0 33px rgba(33,33,33,.2);
}
.variant{
  border: solid;
  margin: 10px;
}
.variant:hover{
  box-shadow: 0 0 33px rgba(33,33,33,.2);
}
.selected-variant{
  background-color: red;
}
</style>
